// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel_panel__HRzod","title":"panel_title__1x81I","titleIcon":"panel_titleIcon__1xxJ_","content":"panel_content__7F9lo"};